<template>
  <div>
    <b-modal
      id="modal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
      :title="titleModal"
    >
      <template #default>
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row d-flex justify-content-lg-center">
            <div class="col-md-12 col-lg-9">
              <div class="form-group">
                <label for="cle">Clé <span class="text-danger">*</span></label>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('cle'),
                  }"
                  id="cle"
                  v-model="form.cle"
                  type="text"
                  placeholder="la clé"
                  maxlength="100"
                  :required="mode !== 'show'"
                  :disabled="mode === 'show'"
                />
                <has-error :form="form" field="cle"></has-error>
              </div>
            </div>
            <div class="col-md-4 col-lg-3 mt-n3 mt-lg-3 pt-2">
              <switches
                v-if="mode === 'show'"
                text-enabled="Statut actif"
                text-disabled="Statut inactif"
                :value="form.statut"
                type-bold="true"
                color="custom-primary"
                class="ml-1 mb-0 font-size-17"
              ></switches>
              <switches
                v-else
                text-enabled="Statut actif"
                text-disabled="Statut inactif"
                v-model="form.statut"
                type-bold="true"
                color="custom-primary"
                class="ml-1 mb-0 font-size-17"
              ></switches>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modal')"
        >
          Fermer
        </button>

        <button
          v-if="mode !== 'show'"
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          {{ mode === 'create' ? 'Créer' : 'Enregistrer' }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/configuration/dictionnaire/cle-param';
import Form from 'vform';

export default {
  data() {
    return {
      form: new Form({
        cle: '',
        statut: true,
      }),
      mode: 'create',
      titleModal: 'Création de nouvelle clé',
    };
  },

  methods: {
    create() {
      this.mode = 'create';
      this.titleModal = 'Création de nouvelle clé';
      this.form.reset();
      this.form.clear();
      this.$bvModal.show('modal');
    },
    async show(id) {
      this.titleModal = "Aperçu d'une clé";
      this.form.reset();
      this.form.clear();
      this.mode = 'show';

      await window.axios
        .get(URL.CLE_PARAM + '/' + id)
        .then((resp) => {
          Object.assign(this.form, resp.data.cleParam);
        })
        .catch();
      await this.$bvModal.show('modal');
    },
    async edit(id) {
      this.titleModal = "Modification d'une clé";
      this.form.reset();
      this.form.clear();
      this.mode = 'edit';

      await window.axios
        .get(URL.CLE_PARAM + '/' + id)
        .then((resp) => {
          Object.assign(this.form, resp.data.cleParam);
        })
        .catch();
      await this.$bvModal.show('modal');
    },
    submit() {
      this.$bvModal.hide('modal');
      if (this.form.id) {
        //update
        this.form
          .put(URL.CLE_PARAM + '/' + this.form.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.form.reset();
            this.form.clear();
            this.$emit('onInit');
          })
          .catch((err) => {
            this.form.errors.set('message', err.response.data.message);
            this.$bvModal.show('modal');
          });
      } else {
        //store
        this.form
          .post(URL.CLE_PARAM)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.form.reset();
            this.form.clear();
            this.$emit('onInit');
          })
          .catch((err) => {
            this.form.errors.set('message', err.response.data.message);
            this.$bvModal.show('modal');
          });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
